import React, {useState} from "react";
import {Box, Button, Column, Columns, Input, TextArea, Title} from "@allxsmith/bestax-bulma";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";

export default function NewRateCard({save}){
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();

    const [rate, setRate] = useState({
        name: "",
        day1_2_rate: 0,
        day3_6_rate: 0,
        day7_27_rate: 0,
        day_28_plus_rate: 0,
        insurance_perc: 0,
        admin_perc: 0,
        description: "",
        contact: undefined
    });

    const clear = () => {
        setRate({
            name: "",
            day1_2_rate: 0,
            day3_6_rate: 0,
            day7_27_rate: 0,
            day_28_plus_rate: 0,
            insurance_perc: 0,
            admin_perc: 0,
            description: "",
            contact: undefined
        })
    }

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const onChange = e => {
        let newRate = {...rate, [e.target.name]: e.target.value};
        setRate(newRate);
    }

    const handleContactSelect = e => {
        const toUpdate = {
            target: {
                name: "contact",
                value: e[0]
            }
        }
        onChange(toUpdate)
    }

    const handleSave = e => {
        save(rate, () => {
            clear();
        });
    }

    return (
        <Box>
            <details>
                <summary><Title>Add Rental Rate Card</Title></summary>
            <Columns isMultiline>
                <Column>
                    <label className="label">Name</label>
                    <Input
                        name={"name"}
                        value={rate.name}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Day 1-2 Rate</label>
                    <Input
                        name={"day1_2_rate"}
                        value={rate.day1_2_rate}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Day 3-6 Rate</label>
                    <Input
                        name={"day3_6_rate"}
                        value={rate.day3_6_rate}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Day 7-27 Rate</label>
                    <Input
                        name={"day7_27_rate"}
                        value={rate.day7_27_rate}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Day 28+ Rate</label>
                    <Input
                        name={"day_28_plus_rate"}
                        value={rate.day_28_plus_rate}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Insurance Charge (%)</label>
                    <Input
                        name={"insurance_perc"}
                        value={rate.insurance_perc}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Admin Charge (%)</label>
                    <Input
                        name={"admin_perc"}
                        value={rate.admin_perc}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Description</label>
                    <TextArea
                        name={"description"}
                        value={rate.description}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Customer</label>
                    <AsyncTypeahead
                      useCache={false}
                      id="typeahead"
                      labelKey="display_name"
                      minLength={2}
                      name={"contact"}
                      onSearch={handleSearch}
                      onChange={handleContactSelect}
                      placeholder={"Search Customer"}
                      options={searchData}
                      ref={typeahead => setTypeahead(typeahead)}
                      className="typeahead"
                      isLoading={isLoading}
                      selected={
                        rate.contact && rate.contact.id ? [rate.contact] : []
                      }
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={handleSave}
                        isFullWidth
                    >
                        Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );



}